import '@/assets/css/style.scss';
if (import.meta.env.VITE_INCLUDE_COMMON === 'true') {
  import('@/assets/css/global-footer.css');
  import('@/assets/js/common/loadHeaderFooter.js').then(module => {
    const loadHeaderFooter = module.default;
    loadHeaderFooter();
  });
  import('@/assets/js/common/components/login.js');
}

import { createApp, ref, onMounted } from './vue.esm-browser.prod.js';
import { productsData, womenLinenData, womenLineupData, menLinenData, menLineupData, storiesData } from './data.js';
import './common/k-tools/k-tools.css';
import { KAnchor, KScrollTrigger, KTab, KScrollspy, KAccordion, AnchorTo } from './common/k-tools/k-tools.js';
import productColorSwitch from './common/colorChips.js';
import LazyLoad from 'vanilla-lazyload';
// import Swiper bundle with all modules installed
import { Swiper } from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';
import videoPlayer from './common/videoPlayer.js';
import { gsapAnimation, gsapAnimationUpdate } from './common/gsapAnimation.js';
import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

const bannerSwiperInit = () => {
  const bannerSwiper = new Swiper('.hero__slider .swiper', {
    speed: 800,
    loop: true,
    autoplay: {
      delay: 6000,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
    },
  });
};

const snapSwiperInit = () => {
  const snapSwiperArray = [];
  $('.snap-swiper').each((index, el) => {
    const paginationEl = $(el).find('.swiper-pagination')[0];
    const prevEl = $(el).find('.swiper-button-prev')[0];
    const nextEl = $(el).find('.swiper-button-next')[0];
    snapSwiperArray[index] = new Swiper(el, {
      slidesPerView: 1.4,
      spaceBetween: 19,
      centeredSlides: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: {
        el: paginationEl,
      },
      breakpoints: {
        1000: {
          slidesPerView: 4,
          spaceBetween: 24,
          centeredSlides: false,
        },
      },
    });
  });
};

const anchorBarHandler = () => {
  const anchorBar = $('section.anchor .anchorBar.fixed');
  const visibleSection = $('section.points');
  const hiddenSection = $('section.care');
  const detectVisibility = () => {
    const scrollTop = $(window).scrollTop();
    // 錨點選單
    if (
      scrollTop >= Math.round(visibleSection.offset().top) &&
      scrollTop < Math.round(hiddenSection.offset().top) - anchorBar.innerHeight()
    ) {
      anchorBar.addClass('show');
    } else {
      anchorBar.removeClass('show');
    }
  };

  const anchorBars = Array.from(document.querySelectorAll('section.anchor .anchorBar.fixed'));
  anchorBars.forEach(element => {
    const anchorBarItems = element.querySelector('.anchorBar__items');
    const anchorNavPrev = element.querySelector('.anchorBar__nav.prev');
    const anchorNavNext = element.querySelector('.anchorBar__nav.next');
    let anchorBarW = anchorBarItems.clientWidth;
    let anchorBarScrollW = anchorBarItems.scrollWidth;
    let anchorBarScrollLeft = anchorBarItems.scrollLeft;
    anchorNavPrev.classList.add('hidden');
    if (anchorBarScrollW <= anchorBarW) {
      anchorNavNext.classList.add('hidden');
    }
    const scrollHandler = () => {
      anchorBarW = anchorBarItems.clientWidth;
      anchorBarScrollW = anchorBarItems.scrollWidth;
      anchorBarScrollLeft = anchorBarItems.scrollLeft;
      if (anchorBarItems.scrollLeft <= 0) {
        anchorNavPrev.classList.add('hidden');
      } else {
        anchorNavPrev.classList.remove('hidden');
      }
      if (anchorBarW + anchorBarScrollLeft >= anchorBarScrollW) {
        anchorNavNext.classList.add('hidden');
      } else {
        anchorNavNext.classList.remove('hidden');
      }
    };
    const anchorMoveHandler = nav => {
      anchorBarW = anchorBarItems.clientWidth;
      anchorBarScrollW = anchorBarItems.scrollWidth;
      anchorBarScrollLeft = anchorBarItems.scrollLeft;
      const distance = nav === 'prev' ? anchorBarScrollLeft - anchorBarW : anchorBarScrollLeft + anchorBarW;
      gsap.to(anchorBarItems, {
        scrollTo: {
          x: distance,
        },
        duration: 0.3,
        ease: 'ease-in-out',
      });
    };
    anchorBarItems.addEventListener('scroll', scrollHandler);
    anchorNavPrev.addEventListener('click', () => anchorMoveHandler('prev'));
    anchorNavNext.addEventListener('click', () => anchorMoveHandler('next'));
  });

  $(window).on('scroll', detectVisibility);
};

const pageInitial = () => {
  const lazyLoadInstance = new LazyLoad({});
  const anchor = new KAnchor('[k-anchor]');
  const scrollTrigger = new KScrollTrigger('[k-st]', {
    start: 'top 80%',
    // marker: true,
  });
  const scrollspy = new KScrollspy('[k-scrollspy]', {
    onEnter: scrollspyID => {
      const anchorBars = Array.from(document.querySelectorAll('section.anchor .anchorBar.fixed'));
      anchorBars.forEach(anchorBar => {
        const anchorBarItems = anchorBar.querySelector('.anchorBar__items');
        const anchorBarW = anchorBarItems.clientWidth;
        const hasHorizontalScrollbar = element => element.scrollWidth > element.clientWidth;
        if (hasHorizontalScrollbar(anchorBarItems)) {
          const anchorItem = anchorBarItems.querySelector(`.anchorBar__item[k-scrollspy-href="${scrollspyID}"]`);
          const itemW = anchorItem?.clientWidth;
          const itemOffsetLeft = anchorItem?.offsetLeft;
          const distance = itemOffsetLeft + itemW / 2 - anchorBarW / 2;
          gsap.to(anchorBarItems, {
            scrollTo: {
              x: distance,
            },
            duration: 0.6,
            ease: 'ease-in-out',
          });
        }
      });
    },
  });
  const accordion = new KAccordion('[k-accordion]', {
    onlyOneOpen: false,
    firstOpen: false,
    onOpenAnchor: false,
  });

  const customAnchor = e => {
    const $this = $(e.currentTarget);
    const anchorTarget = $this.attr('data-anchor');
    const [controlTab, controlPanel] = anchorTarget.split('-');
    const tabEl = document.querySelector(`.nav-tabs__link[k-tab-ctrl="${controlTab}"][k-tab-target="${controlPanel}"]`);
    AnchorTo('.lineup');
    tab.activateTab(tabEl);
  };

  $('.imgAnchor__itemLink').on('click', customAnchor);

  bannerSwiperInit();
  snapSwiperInit();
  videoPlayer();
  anchorBarHandler();
  productColorSwitch();
  gsapAnimation();
};

const page = document.body.dataset.page;

// Vue
createApp({
  setup() {
    const productsDataRef = ref(productsData);
    const linenDataRef = page === 'women' ? ref(womenLinenData) : ref(menLinenData);
    const lineupDataRef = page === 'women' ? ref(womenLineupData) : ref(menLineupData);
    const storiesDataRef = ref(storiesData);
    onMounted(() => {
      setTimeout(() => {
        pageInitial();
      }, 200);
    });
    return {
      productsDataRef,
      linenDataRef,
      lineupDataRef,
      storiesDataRef,
    };
  },
}).mount('#main');
